import type Collection from '@netx/core/lib/netx-collection';
import _ from 'underscore';

import {useEffect, useState} from 'react';
import useComponentIsMounted from './useComponentIsMounted';

/**
 * Handles piping a backbone collection into a react state
 * @deprecated
 */
export default function useBackboneCollection<
	TCollection extends Collection = Collection,
>(collection: TCollection, fetchOnMount = true) {
	const {act} = useComponentIsMounted();

	const [attributes, setAttributes] = useState<
		TCollection['models'][number]['attributes'][]
	>([...collection.models.map((model) => ({...model.attributes}))]);

	// Subscribe to the collection on first render only
	useEffect(() => {
		// Pull the attributes or array of attributes from model or collection
		// Set them on state
		const pullAndSetData = () =>
			act(() =>
				setAttributes([
					...collection.models.map((model) => ({...model.attributes})),
				]),
			);

		pullAndSetData();

		const debouncedPullAndSetData = _.debounce(pullAndSetData, 20);
		collection.on('add change remove reset sort sync', debouncedPullAndSetData);

		const preferredFetchMethod = collection.preferredFetchMethod || 'fetch';
		// @ts-ignore
		fetchOnMount !== false && collection[preferredFetchMethod]();

		// Unsubscribe when component unmounted
		return () => {
			collection.off(undefined, debouncedPullAndSetData);
		};
	}, []);

	return attributes;
}
